import React from "react";

import Heading from "components/heading";

import HeroSection from "../../../hero-section";

const title = "Make Enerflo Your Platform With Custom Integrations";

const MainHero = () => (
  <HeroSection title={title}>
    <div className="flex-grow">
      <HeroSection.Content className="mx-auto md:w-3/4 lg:w-2/3 md:text-center">
        <HeroSection.Header>
          <Heading tag="h1">{title}</Heading>
        </HeroSection.Header>
        <HeroSection.Description>
          If it has an API, Enerflo can integrate it. Your favorite tools make Enerflo more powerful.
        </HeroSection.Description>
      </HeroSection.Content>
    </div>
  </HeroSection>
);

export default MainHero;
